import { _decorator, Label, Font, CCFloat, CCString, CCBoolean, Color, Enum, Overflow } from 'cc';
import LocalizedLabel from '../LocalizedComponent/LocalizedLabel';
import MultiThemeComponent from './MultiThemeComponent';

const { ccclass, property, requireComponent, menu } = _decorator;

@ccclass('MultiThemeLabel')
@menu('MultiTheme/MultiThemeLabel')
@requireComponent(Label)
export default class MultiThemeLabel extends MultiThemeComponent<Label> {
    @property
    private readonly updateContent = false;

    @property({
        type: [CCString],
        visible(this: MultiThemeLabel) {
            return this.updateContent;
        },
    })
    private readonly contents: string[] = [];

    @property
    private readonly updateContentKeys = false;

    @property({
        visible(this: MultiThemeLabel) {
            return this.updateContentKeys;
        },
    })
    private readonly resetStringWhenKeyEmpty: boolean = false;

    @property({
        type: [CCString],
        visible(this: MultiThemeLabel) {
            return this.updateContentKeys;
        },
    })
    private readonly contentKeys: string[] = [];

    @property
    private readonly updateFont: boolean = false;

    @property({
        type: [Font],
        formerlySerializedAs: '_fonts',
        visible(this: MultiThemeLabel) {
            return this.updateFont;
        },
    })
    private readonly fonts: Font[] = [];

    @property
    private readonly updateFontSize: boolean = false;

    @property({
        type: [CCFloat],
        visible(this: MultiThemeLabel) {
            return this.updateFontSize;
        },
    })
    private readonly fontSizes: number[] = [];

    @property
    private readonly updateLineHeight: boolean = false;

    @property({
        type: [CCFloat],
        visible(this: MultiThemeLabel) {
            return this.updateLineHeight;
        },
    })
    private readonly lineHeights: number[] = [];

    @property
    private readonly updateSpacingX: boolean = false;

    @property({
        type: [CCFloat],
        visible(this: MultiThemeLabel) {
            return this.updateSpacingX;
        },
    })
    private readonly spacingX: number[] = [];

    @property
    private readonly updateWrapText: boolean = false;

    @property({
        type: [CCBoolean],
        visible(this: MultiThemeLabel) {
            return this.updateWrapText;
        },
    })
    private readonly wrapText: boolean[] = [];

    @property
    private readonly updateOverflow: boolean = false;

    @property({
        type: [Enum(Overflow)],
        visible(this: MultiThemeLabel) {
            return this.updateOverflow;
        },
    })
    private readonly overflows: Overflow[] = [];

    @property
    private readonly updateIsBold: boolean = false;

    @property({
        type: [CCBoolean],
        visible(this: MultiThemeLabel) {
            return this.updateIsBold;
        },
    })
    private readonly isBold: boolean[] = [];

    @property
    private readonly updateColor: boolean = false;

    @property({
        type: [Color],
        visible(this: MultiThemeLabel) {
            return this.updateColor;
        },
    })
    private readonly colors: Color[] = [];

    private _localizedLabel: LocalizedLabel = null;

    private get localizedLabel() {
        if (!this._localizedLabel) {
            this._localizedLabel = this.target.getComponent(LocalizedLabel);
        }
        return this._localizedLabel;
    }

    public getMaxTheme(): number {
        if (this.updateContent) {
            return this.contents.length;
        }
        if (this.updateContentKeys) {
            return this.contentKeys.length;
        }
        if (this.updateFont) {
            return this.fonts.length;
        }
        if (this.updateFontSize) {
            return this.fontSizes.length;
        }
        if (this.updateSpacingX) {
            return this.spacingX.length;
        }
        if (this.updateOverflow) {
            return this.overflows.length;
        }
        if (this.updateIsBold) {
            return this.isBold.length;
        }
        if (this.updateColor) {
            return this.colors.length;
        }
        if (this.updateLineHeight) {
            return this.lineHeights.length;
        }
        return 0;
    }

    public updateFonts(fonts: Font[]) {
        this.fonts.length = 0;
        this.fonts.push(...fonts);
        this.onThemeChanged();
    }

    protected getTarget() {
        return this.getComponent(Label);
    }

    protected onThemeChanged() {
        if (this.updateContent) {
            this.target.string = this.contents[this._theme];
        }
        if (this.updateContentKeys) {
            this.localizedLabel.key = this.contentKeys[this._theme];
            if (!this.contentKeys[this._theme] && this.resetStringWhenKeyEmpty) {
                this.localizedLabel.reset();
            }
        }
        if (this.updateFont) {
            this.target.font = this.fonts[this._theme];
        }
        if (this.updateFontSize) {
            this.target.fontSize = this.fontSizes[this._theme];
        }
        if (this.updateSpacingX) {
            this.target.spacingX = this.spacingX[this._theme];
        }
        if (this.updateWrapText) {
            this.target.enableWrapText = this.wrapText[this._theme];
        }
        if (this.updateOverflow) {
            this.target.overflow = this.overflows[this._theme];
        }
        if (this.updateIsBold) {
            this.target.isBold = this.isBold[this._theme];
        }
        if (this.updateColor) {
            this.target.color = this.colors[this._theme];
        }
        if (this.updateLineHeight) {
            this.target.lineHeight = this.lineHeights[this._theme];
        }
    }
}
